import { render } from "./ButtonDisplay.vue?vue&type=template&id=12fd9642"
import script from "./ButtonDisplay.vue?vue&type=script&lang=js"
export * from "./ButtonDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__